<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="''"
      :btnClass="'btn-primary'"
      :btnToLink="''"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <h5>検索条件</h5>
    <!-- {{ application_type_group_list }} -->
    <div class="w100 mb-5">
      <div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">申請種別</p>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <bs-select
                :options="application_type_group_list"
                v-model="sprm.application_type_group"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">完了区分</p>
          </div>
          <div class="col-4 mb-2">
            <div class="input-group">
              <bs-select
                :options="application_check_type_display"
                v-model="sprm.application_check_type"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2">
            <p class="text-center py-1 fs-5">ライセンスNo</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <input
                type="text"
                id="MainRecordsNo"
                v-model="sprm.license_no"
                class="form-control"
                @change="search_member_license_no()"
                :disabled="
                  sprm.like_name_1 ||
                  sprm.like_yomi_1 ||
                  sprm.like_name_2 ||
                  sprm.like_yomi_2
                    ? true
                    : false
                "
              />
              <button
                @click="search_member_license_no()"
                :disabled="
                  sprm.like_name_1 ||
                  sprm.like_yomi_1 ||
                  sprm.like_name_2 ||
                  sprm.like_yomi_2
                    ? true
                    : false
                "
                type="button"
                class="btn btn-light btn-outline-secondary"
              >
                ライセンスNoから検索
              </button>
            </div>
          </div>
          <div class="col-3 mb-2">
            <input
              type="text"
              id="MainRecordsNo"
              v-model="search_member_obj.name_label"
              class="form-control"
              placeholder="会員名"
              disabled="true"
            />
          </div>
        </div>
        <!-- <div class="row mb-2">
                    <div class="col-2 mb-2">
                        <p class="text-center py-1 fs-5">氏名/カナ</p>
                    </div>
                    <div class="col-5 mb-2">
                        <input type="text" id="MainRecordsNo" v-model="sprm.like_name" class="form-control "
                            placeholder="会員名" :disabled="(sprm.license_no)? true: false">
                    </div>
                    <div class="col-5 mb-2">
                        <input type="text" id="MainRecordsNo" v-model="sprm.like_yomi" class="form-control "
                            placeholder="会員名(カナ)" :disabled="(sprm.license_no)? true: false">
                    </div>
                </div> -->

        <div class="row mb-2">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">氏名/カナ</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <span class="input-group-text">姓</span>
              <input
                type="text"
                v-model="sprm.like_name_1"
                class="form-control"
                placeholder="姓"
                :disabled="sprm.license_no ? true : false"
              />
              <span class="input-group-text">名</span>
              <input
                type="text"
                v-model="sprm.like_name_2"
                class="form-control"
                placeholder="名"
                :disabled="sprm.license_no ? true : false"
              />
            </div>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <span class="input-group-text">セイ</span>
              <input
                type="text"
                v-model="sprm.like_yomi_1"
                class="form-control"
                placeholder="セイ"
                :disabled="sprm.license_no ? true : false"
              />
              <span class="input-group-text">メイ</span>
              <input
                type="text"
                v-model="sprm.like_yomi_2"
                class="form-control"
                placeholder="メイ"
                :disabled="sprm.license_no ? true : false"
              />
            </div>
          </div>
        </div>

        <div class="row mb-2 d-none">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">申請日</p>
          </div>
          <div class="col-8 mb-2">
            <div class="input-group">
              <input
                type="date"
                v-model="sprm.application_date_higher"
                class="form-control"
                placeholder=""
              />
              <span class="input-group-text">〜</span>
              <input
                type="date"
                v-model="sprm.application_date_lower"
                class="form-control"
                placeholder="会員名"
              />
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2">
            <p class="text-center py-1 fs-5">申請期間</p>
          </div>
          <div class="col-7 mb-2">
            <div class="input-group">
              <input
                type="date"
                v-model="sprm.application_date_higher"
                class="form-control"
                placeholder=""
              />
              <span class="input-group-text">〜</span>
              <input
                type="date"
                v-model="sprm.application_date_lower"
                class="form-control"
                placeholder="会員名"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2 mb-2"></div>
          <div class="col-2 mb-2"></div>
          <div class="col-4 mb-2"></div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">表示件数</p>
          </div>
          <div class="col-2 mb-2">
            <bs-select
              :options="get_page_num_list"
              v-model="page_limit"
              :null-option="true"
              id="MainClinicId"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button
              :btnClass="'btn-primary'"
              @to_click_event="search_application_action"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="w100"
      v-if="
        typeof application_list === 'object' &&
        Object.keys(application_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th>申請No</th>
            <th>申請日時</th>
            <th>完了区分</th>
            <th>申請種別</th>
            <th>ライセンスNo</th>
            <th>会員名</th>
            <th>会員ヨミ</th>
            <th>状態</th>
            <th>経過時間</th>
            <th>前回処理</th>
            <th>今回処理</th>
            <th>対応指示</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in application_list" :key="list.id">
            <td>{{ list.id }}</td>
            <td>{{ list.application_date_label_YmdHi }}</td>
            <td>
              {{
                list.stat == 9
                  ? '取消'
                  : get_label_list(
                      getDisplayStatus(list.application_check_type),
                      application_check_type_display
                    )
              }}
            </td>
            <td>
              {{ get_label_list(list.application_type, application_type_list) }}
            </td>
            <td>{{ list.license_no }}</td>
            <td>
              {{
                list.name_1 || list.name_2
                  ? `${list.name_1 || ''} ${list.name_2 || ''}`
                  : `${list.custom_name_1 || ''} ${list.custom_name_2 || ''}`
              }}
            </td>
            <td>
              {{
                list.yomi_1 || list.yomi_2
                  ? `${list.yomi_1 || ''} ${list.yomi_2 || ''}`
                  : `${list.custom_yomi_1 || ''} ${list.custom_yomi_2 || ''}`
              }}
            </td>
            <td>
              {{
                get_label_list(
                  list.application_check_type,
                  application_check_type_list
                )
              }}
            </td>
            <!-- <td>{{ diff_time(list.diff_time, list.application-date) }}</td> -->
            <td>{{ list.diff_time }}</td>
            <td>{{ list.permission_date }}</td>
            <td>{{ list.permission_manage_label }}</td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >詳細</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
    <bs-page-nav
      :pager_key="'application_list'"
      @to_click_event="pageAction"
    ></bs-page-nav>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
import config from '../../../const'

export default {
  name: 'ApplicationListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '申請データ一覧',
      fromParentBtn: 'データ登録',
      sprm: {
        license_no: '',
        // like_name: '',
        like_name_1: '',
        like_name_2: '',
        like_yomi_1: '',
        like_yomi_2: '',
        application_date: '',
        application_date_higher: '',
        application_date_lower: '',
        search_words: '',
        affiliation: '',
        application_check_type: '',
        application_type: '',
        application_type_group: ''
      },
      page: 0,
      page_limit: 100,
      application_obj: [],
      application_type_obj: [],
      application_type_group_obj: [],
      application_check_type_obj: [],
      search_member_obj: {},
      statusMap: {
        0: '0', // 未登録
        100: '100', // 申請 → 未完了
        120: '100', // 再申請 → 未完了
        200: '100', // 確認 → 未完了
        300: '100', // サーキット回答待 → 未完了
        340: '100', // サーキット回答済 → 未完了
        360: '100', // 書類待ち → 未完了
        400: '500', // 決済待 → 完了
        403: '100', // 決済中 → 完了
        420: '500', // 決済支払待 → 完了
        423: '500', // 即時決済 → 完了
        426: '500', // 即時決済 → 完了
        430: '500', // アンケート未回答 → 完了
        440: '500', // 講習未受講 → 完了
        500: '500', // 手続完了 → 完了
        600: '100', // 訂正依頼中
        900: '900', // 入会取消 → 取消
        990: '990' // 編集禁止
      },
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect,
    BsPageNav
  },
  computed: {
    ...mapState({}),
    // diff_time(){
    //     return function(to_date, from_date){
    //         // const chk_to = (typeof to_date === 'object')? to_date.prototype.toString: to_date;
    //         // const chk_from = (typeof from_date === 'object')? from_date.prototype.toString: from_date;

    //         // console.log('diff_time chk_to', chk_to.call(new Date()), typeof chk_to.call(new Date()));
    //         // console.log('diff_time chk_from', chk_from.call(new Date()), typeof chk_from.call(new Date()));
    //         if(
    //             chk_to.call(new Date())
    //         )
    //     }
    // },
    get_label_list: function () {
      return function (code, lists) {
        if (typeof lists === 'object' && lists.find(list => list.key == code)) {
          return (lists.find(list => list.key == code) || {}).label
        }
        return code
      }
    },
    application_type_list: function () {
      return this.application_type_obj
    },
    application_type_group_list: function () {
      const tmps = []
      if (
        typeof this.application_type_group_obj === 'object' &&
        typeof (this.application_type_group_obj || {}).label === 'object' &&
        typeof (this.application_type_group_obj || {}).cds === 'object'
      ) {
        Object.keys((this.application_type_group_obj || {}).label).forEach(
          lbl_key => {
            if (
              (this.application_type_group_obj || {}).cds[lbl_key] &&
              parseInt(
                (this.application_type_group_obj || {}).cds[lbl_key].key
              ) <= 9999
            ) {
              tmps.push({
                key: (this.application_type_group_obj || {}).cds[lbl_key].label,
                label: (this.application_type_group_obj || {}).label[lbl_key]
                  .label
              })
            }
          }
        )
      }
      return tmps
    },
    application_check_type_list: function () {
      return this.application_check_type_obj
    },
    application_list: function () {
      const lists = [...this.application_obj]
      lists.map(list => {
        list['name_label'] = list.name_1 ? list.name_1 : ''
        list['name_label'] += list.name_2 ? list.name_2 : ''
        list['name_label'] += list.name_3 ? list.name_3 : ''

        return list
      })
      return lists
    },

    application_check_type_display: function () {
      return [
        { key: '100', label: '未完了' }, // 申請中～講習未受講
        { key: '200', label: '対応中' }, // 500にならずに時間が経過したもの
        { key: '500', label: '完了' }, // 手続完了
        { key: '900', label: '取消' } // 入会取消
      ]
    },

    getDisplayStatus: function () {
      const statusMap = this.statusMap
      return function (status) {
        return statusMap[status] || status
      }
    },
    getDisplayStatusR: function () {
      const statusMap = this.statusMap
      return function (status) {
        return Object.keys(statusMap).filter(key => statusMap[key] == status)
      }
    }
  },
  async created() {
    // await this.loadEventCdList();
    // await this.loadLicenseCdList();
    // await this.loadLicenseTypeList();
    // await this.loadRegionList();
    // await this.loadPrefList();
    await this.loadConfigObj('application_check_type')
    await this.loadConfigObj('application_type')
    await this.loadConfigObj('application_type_group')
    // await this.loadApplicationCheckTypeList();
    // await this.loadApplicationTypeList();
    await this.loadSearchParam()
    await this.initialLoad()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '申請データ一覧です。'
  },

  methods: {
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.application_obj.find(app => {
          return app.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', {
            data: data,
            target: 'member_application'
          })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(() => {
            this.loadCateList()
          })
      }
    },
    async loadSearchParam() {
      const params = {
        ...this.$store.getters.getSearchParam('application_list')
      }
      if (params) {
        Object.keys(params).forEach(key => {
          if (this.is_json(params[key])) {
            params[key] = JSON.parse(params[key])
          }
          this.sprm[key] = params[key]
        })
      }
    },

    async search_member_license_no() {
      console.log(
        'license_no',
        this.sprm.license_no,
        typeof this.sprm.license_no
      )
      if (this.sprm.license_no.length == 6) {
        await this.loadMemberList(this.sprm.license_no)
      }
    },
    async loadMemberList(license_no) {
      const params = {}
      params['stat'] = [1]
      params['license_no'] = license_no
      params['pagegroup'] = 'mfj_member_data.id'

      await this.basicPosts_S(config.BASE_API_URL + '/member/lists', params)
        .then(async response => {
          const tmp_obj =
            response.data && response.data.body && response.data.body[0]
              ? response.data.body[0]
              : {}
          let name_label = ''
          if (typeof tmp_obj.name_1 === 'string') name_label += tmp_obj.name_1
          if (typeof tmp_obj.name_2 === 'string') name_label += tmp_obj.name_2
          if (typeof tmp_obj.name_3 === 'string') name_label += tmp_obj.name_3
          tmp_obj.name_label = name_label
          this.search_member_obj = tmp_obj
        })
        .catch(async err => {
          console.log(err)
          this.search_member_obj = {}
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },

    async initialLoad() {
      this.page = 0
      const params = this.prepareSearchParams()
      await this.loadApplicationList(params)
    },

    async search_application_action() {
      this.page = 0
      await this.search_application()
    },
    async search_application() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        const params = this.prepareSearchParams()
        await this.loadApplicationList(params)
      } finally {
        this.isLoading = false
      }
    },
    prepareSearchParams() {
      const params = { stat: [1] }
      if (typeof this.sprm === 'object') {
        Object.keys(this.sprm).forEach(sprm_key => {
          if (
            sprm_key === 'application_type_group' &&
            this.sprm[sprm_key] !== ''
          ) {
            console.log('application_types', this.sprm[sprm_key])
            params['application_types'] = '[' + this.sprm[sprm_key] + ']'
            params['application_type_group'] = this.sprm[sprm_key]
          } else if (
            sprm_key === 'application_check_type' &&
            this.sprm[sprm_key] !== ''
          ) {
            if (this.sprm[sprm_key] == 900) {
              params['stat'] = [9]
            } else {
              params['application_check_types'] = this.getDisplayStatusR(
                this.sprm[sprm_key]
              )
              params['application_check_type'] = this.sprm[sprm_key]
            }
            console.log(
              'getDisplayStatusR',
              this.sprm[sprm_key],
              this.getDisplayStatusR(this.sprm[sprm_key])
            )
          } else if (this.sprm[sprm_key] !== '') {
            params[sprm_key] = this.sprm[sprm_key]
          }
        })
      }
      console.log(
        'prepareSearchParams application_types',
        params.application_types,
        this.sprm
      )
      // 姓名とヨミを結合
      if (this.sprm.like_name_1 || this.sprm.like_name_2) {
        params.like_name = (
          this.sprm.like_name_1 +
          '' +
          this.sprm.like_name_2
        ).trim()
      }
      if (this.sprm.like_yomi_1 || this.sprm.like_yomi_2) {
        params.like_yomi = (
          this.sprm.like_yomi_1 +
          '' +
          this.sprm.like_yomi_2
        ).trim()
      }

      // delete params.like_name_1
      // delete params.like_name_2
      // delete params.like_yomi_1
      // delete params.like_yomi_2

      return params
    },
    async loadApplicationList(params = {}) {
      params['pagelimit'] = this.page_limit
      params['pagelimit_key'] = this.page_limit
      if (this.page >= 0) params['p'] = this.page
      params['pagegroup'] = 'mfj_member_application.id'
      // console.log('loadApplicationList application_types_groupchk', params)
      const save_params = { ...params }
      delete save_params['application_types']
      delete save_params['stat']
      delete params['application_check_type']
      delete params.like_name_1
      delete params.like_name_2
      delete params.like_yomi_1
      delete params.like_yomi_2

      this.$store.dispatch('setSearchParam', {
        data: save_params,
        target: 'application_list'
      })

      try {
        const response = await this.basicPosts_S(
          config.BASE_API_URL + '/member_application/lists',
          params
        )

        console.log('loadApplicationList response', response)
        this.application_obj =
          response.data && response.data.body ? response.data.body : []

        const setPageData = {
          data: response.data && response.data.pager ? response.data.pager : {},
          target: 'application_list'
        }
        this.$store.dispatch('setPager', setPageData)
      } catch (err) {
        console.log(err)
        this.application_obj = []
      } finally {
        this.$forceUpdate()
      }
    },
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'application_list'
      })
    },
    handleClick(target) {
      this.$router.push({ path: '/application/' + target + '/' })
      // console.log('target', target);
      // alert('未設定');
    },
    async pageAction(page) {
      this.page = page
      await this.search_application()
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseTypeList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_type/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseTypeList response', response)
          this.license_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadConfigObj(param) {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/config/' + param, params)
        .then(async response => {
          console.log('loadConfigObj response', response)
          this[param + '_obj'] =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this[param + '_obj'] = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadApplicationTypeList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/application_type',
        params
      )
        .then(async response => {
          console.log('loadApplicationTypeList response', response)
          this.application_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.application_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadApplicationTypeGroupList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/application_type_group',
        params
      )
        .then(async response => {
          console.log('loadApplicationTypeGroupList response', response)
          this.application_type_group_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.application_type_group_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadApplicationCheckTypeList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/application_check_type',
        params
      )
        .then(async response => {
          console.log('loadAffiliationTypeList response', response)
          this.application_check_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.application_check_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    }
  }
}
</script>
